import * as React from 'react';

export type InjectionContextValue = Map<any, any>;

export const InjectionContext = React.createContext<InjectionContextValue>(new Map());
